export default "__VITE_ASSET__D_lnbGPX__"